import type { CampusEvent } from "@/app/types/events";

const EASTERN = "America/New_York";

export function formatSportsEventTime(
  event: Pick<CampusEvent, "source" | "start_time" | "end_time" | "time_confirmed">,
): string {
  if (event.source !== "athletics" || event.time_confirmed === true) {
    return formatEventTime(event.start_time, event.end_time);
  }
  const date = new Date(event.start_time);
  const day = Number.isFinite(date.getTime())
    ? date.toLocaleDateString("en-US", { timeZone: EASTERN, weekday: "short", month: "short", day: "numeric", year: "numeric" })
    : "Date not provided";
  return `${day} · ${event.time_confirmed === false ? "Time not confirmed" : "Time not verified"}`;
}

/** Display the full attendance date, using Eastern time even outside New Jersey. */
export function formatEventTime(start: string, end: string | null): string {
  const startDate = new Date(start);
  if (!Number.isFinite(startDate.getTime())) return "Time not provided";
  const full = (date: Date) => date.toLocaleString("en-US", {
    timeZone: EASTERN, weekday: "short", month: "short", day: "numeric",
    hour: "numeric", minute: "2-digit", timeZoneName: "short",
  });
  const startText = full(startDate);
  if (!end) return startText;
  const endDate = new Date(end);
  if (!Number.isFinite(endDate.getTime()) || endDate <= startDate) return startText;
  const sameDate = startDate.toLocaleDateString("en-US", { timeZone: EASTERN }) === endDate.toLocaleDateString("en-US", { timeZone: EASTERN });
  const endText = sameDate ? endDate.toLocaleString("en-US", {
    timeZone: EASTERN, hour: "numeric", minute: "2-digit", timeZoneName: "short",
  }) : full(endDate);
  return `${startText} – ${endText}`;
}
